import { apiUrl, apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  dailyOps: null,
  dailyOp: undefined,
}

const createDailyOpsSlice = (set, get) => ({
  ...initialState,
  fetchDailyOps: async () => {
    try {
      const response = await fetch(
        `${apiUrlV2}/daily_ops?branch_id=${get().selectedBranch[0]}`,
        {headers: get().requestHeaders}
      )
      if (response.status === 200) {
        const data = await response.json()

        if(get().user) {
          set((state) => ({ dailyOps: data }))
        }
      }
    } catch (err) {
      get().logError('Daily Ops data was unable to be fetched.', err)
    }
  },
  resetDailyOpsSlice: () => set(initialState)
})

export default createDailyOpsSlice
